module.exports = __webpack_public_path__ + "static/media/ashley.bd7cdbe6.webp";